import { render } from "./OcrSnackbar.vue?vue&type=template&id=17a29ca0"
import script from "./OcrSnackbar.vue?vue&type=script&lang=js"
export * from "./OcrSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__